import { useGuaziSectionHref } from '@/hooks/guaziUseSectionNav';

export default function GuaziMascotBand() {
  const sectionHref = useGuaziSectionHref();

  return (
    <section className="w-full bg-background-100 px-4 md:px-6 py-14 md:py-20">
      <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
        <div className="w-full lg:w-1/2 flex items-center justify-center">
          <img
            src="/images/guazi-mascot-1.png"
            alt="瓜子影视吉祥物形象"
            title="瓜子影视APP下载官网"
            className="w-[180px] md:w-[280px] guazi-float"
          />
        </div>

        <div className="w-full lg:w-1/2 text-center lg:text-left">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-secondary-100 text-secondary-700 rounded-full text-xs md:text-sm font-bold">
            <i className="ri-emotion-happy-line text-base" />
            瓜子吉祥物
          </span>
          <h2 className="mt-4 font-heading font-extrabold text-3xl md:text-4xl text-foreground-950">
            瓜子陪你看好剧
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-7">
            这颗小瓜子是瓜子影视的形象担当，负责陪你把每一部好剧看完。瓜子影视希望用最轻松的方式，让找片和追剧都变得简单。
          </p>
          <a
            href={sectionHref('features')}
            className="mt-7 inline-flex items-center gap-2 px-6 py-3 bg-secondary-500 text-background-50 text-sm font-bold rounded-md hover:bg-secondary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-list-check-2 text-base" />
            查看功能特色
          </a>
        </div>
      </div>
    </section>
  );
}